import React from 'react'
import moment from 'moment'
import { browserHistory } from 'react-router'
import { getExperienceId } from '../ExperiencesApp/ExperiencesApp'
import { connect } from 'react-redux'
import { Map, OrderedMap, Set } from 'immutable'
import { CircleSpinner } from 'common/spinners'
import { SectionBox } from 'common/styleguide/SectionBox'
import { CheckboxGroup } from 'common/styleguide/CheckboxGroup'
import { DatePickerInput } from 'common/styleguide/DatePickerInput'
import { ImageUpload } from 'common/styleguide/ImageUpload'
import { CTA } from 'common/styleguide/CTA'
import styles from './Details.scss'
import layout from '../layout.scss'
// import cx from 'classnames'
// import plusIcon from 'assets/images/goals/plusIcon.svg'
import { experienceSelectors, experienceActions } from 'data/resources/experiences'
import Helmet from 'react-helmet'

const dateFormat = 'YYYY-MM-DD'

const reduceBlobURL = image => (
  !image || typeof image === 'string'
    ? image
    : image.preview
)

export class _Details extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      pendingEdits: Map()
    }
  }

  componentDidMount () {
    this.props.loadExperience()
    window.addEventListener('beforeunload', this.onBeforeUnload)
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
  }

  componentWillUnmount () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  }

  onBeforeUnload = (e) => {
    const { pendingEdits } = this.state
    if (pendingEdits.size !== 0) {
      // Cancel the event
      e.preventDefault()
      // We don't have control over this string in newer browsers, so just use
      // the Chrome default text:
      const prompt = 'Do you want to leave this site? Changes you made may not be saved.'
      // Chrome requires returnValue to be set
      e.returnValue = prompt
      return prompt
    }
  }

  routerWillLeave = () => {
    const { pendingEdits } = this.state
    if (pendingEdits.size !== 0) {
      // we DO have control over this one
      return 'You have unsaved changes to your Experience - are you sure you want to leave without saving?'
    }
  }

  componentDidUpdate (prevProps) {
    const { loadExperience } = this.props
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      loadExperience()
    }
  }

  setPendingEdit (key, value) {
    const { pendingEdits } = this.state
    this.setState({ pendingEdits: pendingEdits.merge({ [key]: value }) })
  }

  onInputChange = (e) => {
    this.setPendingEdit(e.target.name, e.target.value)
  }

  onRequestInfoChange = (checked) => {
    const { pendingEdits } = this.state
    const newPendingEdits = pendingEdits.withMutations(m => {
      ['requireName', 'requirePhone', 'requireEmail', 'requireReferenceId', 'requireZipCode'].forEach(key => {
        m.set(key, checked.has(key))
      })
    })
    this.setState({ pendingEdits: newPendingEdits })
  }

  onSocialChange = (checked) => {
    const { pendingEdits } = this.state
    const newPendingEdits = pendingEdits.withMutations(m => {
      ['includeFacebook', 'includeTwitter', 'includeInstagram'].forEach(key => {
        m.set(key, checked.has(key))
      })
    })
    this.setState({ pendingEdits: newPendingEdits })
  }

  onUseDatesChange = (e) => {
    const { pendingEdits } = this.state
    if (e.target.checked) {
      // set default dates, datepicker doesnt play nice with null values
      this.setState({ pendingEdits: pendingEdits.merge({
        startsOn: moment(new Date()).format(dateFormat),
        endsOn: moment(new Date()).format(dateFormat)
      }) })
    }
    if (!e.target.checked) {
      this.setState({ pendingEdits: pendingEdits.merge({
        startsOn: null,
        endsOn: null
      }) })
    }
    this.setState({ useDates: e.target.checked })
  }

  onStartsOnChange = (startsOn) => {
    this.setPendingEdit('startsOn', moment(startsOn).format(dateFormat))
  }

  onEndsOnChange = (endsOn) => {
    this.setPendingEdit('endsOn', moment(endsOn).format(dateFormat))
  }

  onLogoChange = (files) => {
    if (files && files[0]) {
      this.setPendingEdit('logo', files[0])
    }
  }

  onCoverChange = (files) => {
    if (files && files[0]) {
      this.setPendingEdit('cover', files[0])
    }
  }

  saveChanges = (e) => {
    e.preventDefault()
    const { experience, updateExperience } = this.props
    const { pendingEdits, useDates } = this.state
    let updatedExperience = experience.merge(pendingEdits)
    if (useDates === false) {
      updatedExperience = updatedExperience.merge({ startsOn: null, endsOn: null })
    }
    this.setState({
      savePending: true
    })
    updateExperience(updatedExperience).then(() => {
      this.setState({
        pendingEdits: Map(),
        savePending: false
      })
      browserHistory.push(`/experiences/${experience.id}/edit`)
    })
  }

  render () {
    const { experience, allowNoExpire } = this.props
    const { savePending, pendingEdits } = this.state

    if (!experience) {
      return (<div />)
    }

    const useDates = !!(this.state.useDates === undefined ? experience.startsOn && experience.endsOn : this.state.useDates)

    const values = experience && experience.merge(pendingEdits)

    return (
      <form onSubmit={this.saveChanges}>
        {experience && <Helmet title={experience.name} />}
        <div className={layout.container}>
          <div className={layout.mainColumn}>
            <SectionBox title='Details'>
              <div>
                <label>Title</label>
                <input type='text' value={values.name} name='name' onChange={this.onInputChange} />
              </div>
              <div>
                <label>
                  <input type='checkbox' checked={useDates} onChange={this.onUseDatesChange} />
                  Use Dates
                </label>
              </div>
              {useDates && <div style={{ display: 'flex' }}>
                <div style={{ width: '122px' }}>
                  <label>Starts</label>
                  <DatePickerInput
                    date={moment(values.startsOn).toDate()}
                    dateFormat={dateFormat}
                    onDateChange={this.onStartsOnChange} />
                </div>
                <div style={{ padding: '35px 20px 0 20px' }}>to</div>
                <div style={{ width: '122px' }}>
                  <label>Ends</label>
                  <DatePickerInput
                    date={moment(values.endsOn).toDate()}
                    dateFormat={dateFormat}
                    onDateChange={this.onEndsOnChange} />
                </div>
              </div>}
              <div>
                <label>Location</label>
                <input type='text' value={values.location} name='location' onChange={this.onInputChange} />
              </div>
              <div>
                <label>Description</label>
                <textarea value={values.description || ''} name='description' onChange={this.onInputChange} />
              </div>
              <div>
                <label>Logo (150 x 150px)</label>
                <div style={{ width: '150px' }}>
                  <ImageUpload
                    onDrop={this.onLogoChange}
                    hintTop={`Drop a logo here`}>
                    <img height='90' src={reduceBlobURL(values.logo)} />
                  </ImageUpload>
                </div>
              </div>
              <div>
                <label>Cover Photo (1280 x 740px)</label>
                <ImageUpload
                  className={styles.imageUploadWithNote}
                  onDrop={this.onCoverChange}
                  hintTop={`Drop a photo for your cover here`}>
                  <img height='90' src={reduceBlobURL(values.cover)} />
                </ImageUpload>
                <div className={styles.imageHint}>
                  Recommended file size no larger than 10MB
                </div>
              </div>
              <div>
                <label>Ask for information from guests when they RSVP</label>
                <CheckboxGroup
                  options={OrderedMap({
                    requireName: 'First and last name',
                    requireEmail: 'Email address',
                    requirePhone: 'Phone number',
                    requireReferenceId: 'Reference ID',
                    requireZipCode: 'Zip code'
                  })}
                  selected={Set(['requireName', 'requireEmail', 'requirePhone', 'requireReferenceId', 'requireZipCode'].filter(k => values[k]))}
                  horizontal
                  onChange={this.onRequestInfoChange} />
              </div>
              <div>
                <label>Expire guests after accessing your Experience</label>
                <select style={{ width: '170px' }} value={values.expireAfterDays} name='expireAfterDays' onChange={this.onInputChange}>
                  {allowNoExpire && <option key={0} value={0}>Do not expire</option>}
                  {allowNoExpire && [3, 5].map(days => (
                    <option key={days} value={days}>{days} days</option>
                  ))}
                  {[15, 30].map(days => (
                    <option key={days} value={days}>{days} days</option>
                  ))}
                  {allowNoExpire && [45, 60].map(days => (
                    <option key={days} value={days}>{days} days</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Reference ID</label>
                <input value={values.referenceId} name='referenceId' onChange={this.onInputChange} type='text' />
              </div>
              <div>
                <label>Include social links on Experience home page</label>
                <CheckboxGroup
                  options={OrderedMap({
                    includeFacebook: 'Facebook',
                    includeTwitter: 'Twitter',
                    includeInstagram: 'Instagram'
                  })}
                  selected={Set(['includeFacebook', 'includeTwitter', 'includeInstagram'].filter(k => values[k]))}
                  horizontal
                  onChange={this.onSocialChange} />
              </div>
            </SectionBox>
          </div>
          <div className={layout.sideColumn}>
            <SectionBox title='Save' style={{ paddingTop: '10px', paddingBottom: '10px' }}>
              <CTA button disabled={savePending || pendingEdits.size === 0} type='submit'>
                {savePending && <CircleSpinner size={14} />}
                {savePending && <span style={{ marginLeft: '10px' }}>Saving...</span>}
                {!savePending && pendingEdits.size === 0 && 'Changes Saved'}
                {!savePending && pendingEdits.size > 0 && 'Save Changes'}
              </CTA>
              <CTA link onClick={() => browserHistory.push(`/experiences/${experience.id}/edit`)}>Cancel</CTA>
            </SectionBox>
          </div>
        </div>
      </form>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps)

  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    updateExperience: (experience) => dispatch(experienceActions.update(experience))
  }
}

const mapStateToProps = (state, ownProps) => ({
  experience: experienceSelectors.find(state, getExperienceId(ownProps)),
  allowNoExpire: experienceSelectors.allowNoExpire(state, getExperienceId(ownProps))
})

export const Details = connect(
  mapStateToProps,
  mapDispatchToProps
)(_Details)
